module.exports = __webpack_public_path__ + "images/emoji/fast_forward.ca6f8361066927199f45.png";